import { render, staticRenderFns } from "./AlterarDescricaoCarga.vue?vue&type=template&id=26b88fd0&"
import script from "./AlterarDescricaoCarga.vue?vue&type=script&lang=js&"
export * from "./AlterarDescricaoCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports